module.exports = __webpack_public_path__ + "img/price-settings-mobile-en.869512de.jpg";